import { useParams } from "react-router-dom";
import { useCDPRole } from "../cdp-role-context";
import Loader from "../common/loader";
import PlatformViewForm from "../components/platforms/platform-view-form";
import { useFeatureFlagQuery } from "../hasura.graphql";

const PlatformById: React.FC<{ header: string; url: string }> = ({
  header,
  url,
}) => {
  const { id } = useParams();
  const { setCDPRole } = useCDPRole();
  const { data, loading, error } = useFeatureFlagQuery({
    onCompleted: (data) => {
      setCDPRole(data.feature_flag.map((feat) => feat.feature));
    },
  });
  if (loading)
    return (
      <div className="mx-6 mt-4">
        <Loader />
      </div>
    );
  if (error) return null;
  if (!data) return null;

  return (
    <PlatformViewForm
      header={header}
      isModal={false}
      platformId={id!}
      url={url}
    />
  );
};

export default PlatformById;
